export default "__VITE_ASSET__5d30b897__"